import { getCookie, setCookie } from './cookies';
export const isAllowedLanguage = (lang) => {
    const allowedLanguages = [
        'pl',
        'en',
        'cs',
        'de',
        'es',
        'fr',
        'it',
        'nl',
        'ru',
        'sk',
        'uk'
    ];
    if (allowedLanguages.indexOf(lang) > -1) {
        return true;
    }
    return false;
};
export const getLocaleLanguageOrDefault = () => {
    const language = (navigator.languages && navigator.languages[0]) || navigator.language;
    let locale = language.toLowerCase().split(/[_-]+/)[0];
    if (!isAllowedLanguage(locale)) {
        locale = 'en';
    }
    return locale;
};
export const setLanguageCookie = (value) => {
    setCookie('lang', value, Number(new Date(new Date().getTime() + 86400000)));
};
export const getLanguageCookie = () => {
    const storageLang = getCookie('lang');
    if (storageLang && isAllowedLanguage(storageLang)) {
        return storageLang;
    }
    return null;
};
export const setNotLoggedLanguageCookie = (value) => {
    setCookie('select-lang', value, Number(new Date(new Date().getTime() + 86400000)));
};
export const getNotLoggedLanguageCookie = () => {
    const storageLang = getCookie('select-lang');
    if (storageLang && isAllowedLanguage(storageLang)) {
        return storageLang;
    }
    return null;
};
export const getAppLanguage = (lang) => {
    return lang !== 'default' ? lang : getLocaleLanguageOrDefault();
};
